import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../App";
import { useNavigate } from "react-router-dom";
import Avatar from "../components/Avatar";
import { API } from "../api";

function Planning() {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const [leaves, setLeaves] = useState([]);
  const [tts, setTts] = useState([]);
  const [members, setMembers] = useState([]);
  const [monthOffset, setMonthOffset] = useState(0);
  const [tooltip, setTooltip] = useState(null);
  const [feries, setFeries] = useState({});

  useEffect(() => {
    const headers = { Authorization: "Bearer " + token };
    let leavesUrl, usersUrl;
    if (user.role === "daf") {
      leavesUrl = `${API}/leaves/team`;
      usersUrl = `${API}/users`;
    } else if (user.role === "associe") {
      leavesUrl = `${API}/leaves/team`;
      usersUrl = `${API}/users/team`;
    } else {
      leavesUrl = `${API}/leaves/myteam`;
      usersUrl = `${API}/users/myteam`;
    }
    Promise.all([
      axios.get(leavesUrl, { headers }),
      axios.get(usersUrl, { headers }),
      axios.get(`${API}/tt/team`, { headers })
    ]).then(([leavesRes, usersRes, ttRes]) => {
      setTts(ttRes.data);
      if (user.role === "associe") {
        axios.get(`${API}/leaves/mine`, { headers })
          .then(myRes => setLeaves([...leavesRes.data, ...myRes.data]));
        const team = usersRes.data.map(u => ({ id: u.id, nom: u.nom, prenom: u.prenom, role: u.role }));
        if (!team.find(m => m.id === user.id)) team.unshift({ id: user.id, nom: user.nom, prenom: user.prenom, role: user.role });
        setMembers(team);
      } else if (user.role === "daf") {
        setLeaves(leavesRes.data);
        setMembers(usersRes.data.filter(u => u.role !== "daf").map(u => ({ id: u.id, nom: u.nom, prenom: u.prenom, role: u.role })));
      } else {
        setLeaves(leavesRes.data);
        setMembers(usersRes.data.map(u => ({ id: u.id, nom: u.nom, prenom: u.prenom, role: u.role })));
      }
    }).catch(err => console.error(err));
  }, [token, user.role, user.id]);

  const today = new Date();
  const todayStr = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");

  // Générer les données pour N mois à partir de monthOffset
  const months = [0, 1, 2].map(delta => {
    const d = new Date(today.getFullYear(), today.getMonth() + monthOffset + delta, 1);
    const year = d.getFullYear();
    const month = d.getMonth();
    const daysCount = new Date(year, month + 1, 0).getDate();
    const days = Array.from({ length: daysCount }, (_, i) => {
      const dd = new Date(year, month, i + 1);
      const str = dd.getFullYear() + "-" + String(dd.getMonth() + 1).padStart(2, "0") + "-" + String(dd.getDate()).padStart(2, "0");
      return { date: dd, str, num: i + 1, dayName: dd.toLocaleDateString("fr-FR", { weekday: "short" }).slice(0, 2) };
    });
    return { year, month, days, label: d.toLocaleDateString("fr-FR", { month: "long", year: "numeric" }) };
  });

  const currentYear = months[0].year;

  useEffect(() => {
    const headers = { Authorization: "Bearer " + token };
    // Charger les fériés pour toutes les années couvertes
    const years = [...new Set(months.map(m => m.year))];
    Promise.all(years.map(y =>
      axios.get(`${API}/feries/${y}`, { headers }).then(r => r.data).catch(() => [])
    )).then(results => {
      const map = {};
      results.flat().forEach(f => { map[f.date] = f.name; });
      setFeries(map);
    });
  }, [token, currentYear, monthOffset]);

  const getLeave = (userId, dateStr) =>
    leaves.find(l => l.user_id === userId && l.date_debut.substring(0, 10) <= dateStr && l.date_fin.substring(0, 10) >= dateStr);

  const getTT = (userId, dateStr) =>
    tts.find(t => t.user_id === userId && t.date_debut.substring(0, 10) <= dateStr && t.date_fin.substring(0, 10) >= dateStr);

  const isWeekend = d => d.getDay() === 0 || d.getDay() === 6;

  const halfBg = (periode) => {
    if (periode === "apres-midi") return "linear-gradient(to top left,#B5D4F4 50%,#fff 50%)";
    return "linear-gradient(to bottom right,#B5D4F4 50%,#fff 50%)"; // matin (défaut)
  };

  const getCellStyle = (leave, tt, isWknd, isFerieDay, isToday, dateStr) => {
    let style;
    if (isWknd || isFerieDay) {
      style = { background: "#f5f5f7", borderColor: "#ebebeb" };
    } else if (leave && leave.type === "Absence") {
      if (leave.periode === "matin") style = { background: "linear-gradient(to bottom right,#F5D279 50%,#fff 50%)", borderColor: "#e0b948" };
      else if (leave.periode === "apres-midi") style = { background: "linear-gradient(to top left,#F5D279 50%,#fff 50%)", borderColor: "#e0b948" };
      else style = { background: "#F5D279", borderColor: "#e0b948" };
    } else if (leave && leave.statut === "approved") {
      const jours = parseFloat(leave.jours);
      const hasHalf = jours % 1 !== 0;
      const isLastDay = dateStr === leave.date_fin.substring(0, 10);
      const isFirstDay = dateStr === leave.date_debut.substring(0, 10);
      if (jours === 0.5) {
        style = { background: halfBg(leave.periode || "matin"), borderColor: "#9dbfe8" };
      } else if (hasHalf && isLastDay) {
        style = { background: halfBg("matin"), borderColor: "#9dbfe8" };
      } else if (hasHalf && isFirstDay && leave.periode === "apres-midi") {
        style = { background: halfBg("apres-midi"), borderColor: "#9dbfe8" };
      } else {
        style = { background: "#B5D4F4", borderColor: "#9dbfe8" };
      }
    } else if (leave && leave.statut === "pending") {
      style = { background: "repeating-linear-gradient(45deg, #dde8f5, #dde8f5 2px, #f8fbff 2px, #f8fbff 7px)", borderColor: "#ccd9ec" };
    } else if (tt) {
      if (tt.periode === "matin") style = { background: "linear-gradient(to bottom right,#B8E6C8 50%,#fff 50%)", borderColor: "#9dd4b0" };
      else if (tt.periode === "apres-midi") style = { background: "linear-gradient(to top left,#B8E6C8 50%,#fff 50%)", borderColor: "#9dd4b0" };
      else style = { background: "#B8E6C8", borderColor: "#9dd4b0" };
    } else {
      style = { background: "#fff", borderColor: "#f0f0f0" };
    }
    // "Aujourd'hui" : contour violet qui ne masque pas le contenu (TT, congé...)
    if (isToday) {
      if (style.background === "#fff") style = { background: "#EDE9FF", borderColor: "#c5b8f8" };
      style = { ...style, outline: "2px solid #7C6FE0", outlineOffset: -2 };
    }
    return style;
  };

  const roleBadge = (role) => {
    if (role === "associe") return { color: "#185FA5", bg: "#E6F1FB", label: "Associé" };
    if (role === "assistante") return { color: "#854F0B", bg: "#FAEEDA", label: "Assistante" };
    return { color: "#555", bg: "#f0f0f0", label: "Collab" };
  };

  const isClickable = (m, d, leave) =>
    m.id === user.id && !isWeekend(d.date) && !feries[d.str] && !leave && d.str >= todayStr;

  const renderMonthTable = ({ days, label }) => (
    <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", marginBottom: 20 }}>
      {/* Titre du mois */}
      <div style={{ padding: "10px 16px", borderBottom: "1px solid #eee", background: "#fafafa" }}>
        <span style={{ fontSize: 14, fontWeight: 700, color: "#444", textTransform: "capitalize" }}>{label}</span>
      </div>
      <div style={{ overflowX: "auto" }}>
        <table style={{ borderCollapse: "collapse", fontSize: 12, tableLayout: "fixed", width: "100%", minWidth: 680 }}>
          <thead>
            <tr style={{ background: "#fafafa" }}>
              <th style={{ width: 180, minWidth: 180, textAlign: "left", padding: "8px 14px", color: "#999", fontWeight: 500, fontSize: 11, borderBottom: "1px solid #eee", position: "sticky", left: 0, background: "#fafafa", zIndex: 2 }}>
                Collaborateur
              </th>
              {days.map(d => {
                const isWknd = isWeekend(d.date);
                const isFerie = !!feries[d.str];
                const isGray = isWknd || isFerie;
                return (
                  <th key={d.str} title={isFerie ? feries[d.str] : undefined}
                    style={{
                      width: 32, minWidth: 32, textAlign: "center", padding: "6px 1px",
                      borderBottom: "1px solid #eee",
                      background: d.str === todayStr ? "#EDE9FF" : isGray ? "#f5f5f7" : "#fafafa",
                      cursor: isFerie ? "help" : undefined,
                    }}>
                    <div style={{ fontSize: 9, color: isGray ? "#ccc" : d.str === todayStr ? "#7C6FE0" : "#bbb", fontWeight: 500, lineHeight: 1 }}>{d.dayName}</div>
                    <div style={{ fontSize: 12, color: isGray ? "#ccc" : d.str === todayStr ? "#7C6FE0" : "#666", fontWeight: d.str === todayStr ? 700 : 500 }}>{d.num}</div>
                    {d.str === todayStr && <div style={{ width: 4, height: 4, background: "#7C6FE0", borderRadius: "50%", margin: "2px auto 0" }} />}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {members.map((m, idx) => {
              const badge = roleBadge(m.role);
              return (
                <tr key={m.id} style={{ background: idx % 2 === 0 ? "#fff" : "#fdfcff" }}>
                  <td style={{
                    padding: "5px 14px", whiteSpace: "nowrap", borderBottom: "1px solid #f5f5f5",
                    position: "sticky", left: 0, zIndex: 1, background: idx % 2 === 0 ? "#fff" : "#fdfcff",
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <Avatar prenom={m.prenom} nom={m.nom} size={26} fontSize={10} />
                      <div>
                        <div style={{ fontSize: 12, fontWeight: 600, color: "#333", lineHeight: 1.2 }}>{m.prenom} {m.nom}</div>
                        <span style={{ fontSize: 10, color: badge.color, background: badge.bg, padding: "1px 6px", borderRadius: 10, fontWeight: 500 }}>{badge.label}</span>
                      </div>
                    </div>
                  </td>
                  {days.map(d => {
                    const leave = getLeave(m.id, d.str);
                    const tt = !leave ? getTT(m.id, d.str) : null;
                    const isFerie = !!feries[d.str];
                    const cellStyle = getCellStyle(leave, tt, isWeekend(d.date), isFerie, d.str === todayStr, d.str);
                    const clickable = isClickable(m, d, leave);
                    return (
                      <td key={d.str}
                        onMouseEnter={e => {
                          if (leave && leave.type === "Absence") {
                            const pLabel = leave.periode === "matin" ? " (matin)" : leave.periode === "apres-midi" ? " (après-midi)" : "";
                            setTooltip({ x: e.clientX, y: e.clientY, text: `Jour non travaillé${pLabel} — ${new Date(leave.date_debut).toLocaleDateString("fr-FR")}` });
                          } else if (leave) {
                            const j = parseFloat(leave.jours);
                            const halfLabel = j === 0.5 ? ` — ${leave.periode === 'apres-midi' ? 'Après-midi' : 'Matin'}` : j % 1 !== 0 ? ' (dernière ½j matin)' : '';
                            setTooltip({ x: e.clientX, y: e.clientY, text: `${leave.type} — ${new Date(leave.date_debut).toLocaleDateString("fr-FR")} → ${new Date(leave.date_fin).toLocaleDateString("fr-FR")} (${j}j${halfLabel}) — ${leave.statut === "approved" ? "Approuvé" : "En attente"}` });
                          } else if (tt) {
                            const periodeLabel = tt.periode === "matin" ? " (matin)" : tt.periode === "apres-midi" ? " (après-midi)" : "";
                            setTooltip({ x: e.clientX, y: e.clientY, text: `Télétravail${periodeLabel} — ${new Date(tt.date_debut).toLocaleDateString("fr-FR")} → ${new Date(tt.date_fin).toLocaleDateString("fr-FR")}` });
                          } else if (isFerie) setTooltip({ x: e.clientX, y: e.clientY, text: `🗓️ ${feries[d.str]}` });
                          else if (clickable) setTooltip({ x: e.clientX, y: e.clientY, text: "Cliquer pour poser un congé" });
                        }}
                        onMouseLeave={() => setTooltip(null)}
                        onClick={() => clickable && navigate(`/demande?date=${d.str}`)}
                        style={{
                          height: 32, width: 32, ...cellStyle,
                          border: `1px solid ${cellStyle.borderColor}`,
                          borderRadius: 4, cursor: clickable ? "pointer" : "default",
                        }}
                      />
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontWeight: 600, fontSize: 18 }}>👥 Planning équipe</h2>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button onClick={() => setMonthOffset(0)}
            style={{ padding: "5px 12px", background: monthOffset === 0 ? "#7C6FE0" : "#f0f0f0", color: monthOffset === 0 ? "#fff" : "#555", border: "none", borderRadius: 6, fontSize: 12, cursor: "pointer", fontWeight: 500 }}>
            Aujourd'hui
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: 4, background: "#fff", border: "1px solid #e0e0e0", borderRadius: 8, padding: "4px 8px" }}>
            <button onClick={() => setMonthOffset(o => o - 1)}
              style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16, color: "#7C6FE0", padding: "0 4px", lineHeight: 1 }}>‹</button>
            <span style={{ fontSize: 14, fontWeight: 600, color: "#333", minWidth: 80, textAlign: "center", textTransform: "capitalize" }}>
              {months[0].label} – {months[2].label}
            </span>
            <button onClick={() => setMonthOffset(o => o + 1)}
              style={{ background: "none", border: "none", cursor: "pointer", fontSize: 16, color: "#7C6FE0", padding: "0 4px", lineHeight: 1 }}>›</button>
          </div>
        </div>
      </div>

      {/* Légende */}
      <div style={{ display: "flex", gap: 16, marginBottom: 16, flexWrap: "wrap" }}>
        {[
          { bg: "#B5D4F4", label: "Congé approuvé" },
          { bg: "repeating-linear-gradient(45deg,#dde8f5,#dde8f5 2px,#f8fbff 2px,#f8fbff 7px)", label: "En attente", border: "1px solid #ccd9ec" },
          { bg: "linear-gradient(to bottom right,#B5D4F4 50%,#fff 50%)", label: "½ j. matin", border: "1px solid #9dbfe8" },
          { bg: "linear-gradient(to top left,#B5D4F4 50%,#fff 50%)", label: "½ j. après-midi", border: "1px solid #9dbfe8" },
          { bg: "#B8E6C8", label: "Télétravail" },
          { bg: "linear-gradient(to bottom right,#B8E6C8 50%,#fff 50%)", label: "½ j. TT matin", border: "1px solid #9dd4b0" },
          { bg: "linear-gradient(to top left,#B8E6C8 50%,#fff 50%)", label: "½ j. TT après-midi", border: "1px solid #9dd4b0" },
          { bg: "#EDE9FF", label: "Aujourd'hui", border: "1px solid #c5b8f8" },
          { bg: "#f5f5f7", label: "Jour férié", border: "1px solid #ebebeb" },
          { bg: "#F5D279", label: "Jour non travaillé", border: "1px solid #e0b948" },
        ].map(({ bg, label, border }) => (
          <span key={label} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "#666" }}>
            <span style={{ width: 14, height: 14, background: bg, borderRadius: 3, display: "inline-block", border: border || "1px solid rgba(0,0,0,0.06)", flexShrink: 0 }}></span>
            {label}
          </span>
        ))}
      </div>

      {/* Vue liste mobile */}
      <div className="planning-list-view" style={{ display: "none" }}>
        {months.map(({ label, month, year }) => {
          const absences = members.map(m => {
            const badge = roleBadge(m.role);
            const myLeaves = leaves.filter(l =>
              l.user_id === m.id &&
              (l.statut === "approved" || l.statut === "pending") &&
              new Date(l.date_debut).getFullYear() === year &&
              new Date(l.date_debut).getMonth() === month
            );
            return { m, badge, myLeaves };
          }).filter(({ myLeaves }) => myLeaves.length > 0);
          return (
            <div key={label} style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#555", textTransform: "capitalize", marginBottom: 8 }}>{label}</div>
              {absences.length === 0
                ? <div style={{ fontSize: 13, color: "#bbb", padding: "10px 0" }}>Aucune absence ce mois</div>
                : absences.map(({ m, badge, myLeaves }) => (
                  <div key={m.id} style={{ background: "#fff", border: "1px solid #eee", borderRadius: 10, padding: "12px 14px", marginBottom: 8 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                      <Avatar prenom={m.prenom} nom={m.nom} size={30} fontSize={11} />
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 600 }}>{m.prenom} {m.nom}</div>
                        <span style={{ fontSize: 10, color: badge.color, background: badge.bg, padding: "1px 6px", borderRadius: 10 }}>{badge.label}</span>
                      </div>
                    </div>
                    {myLeaves.map(l => (
                      <div key={l.id} style={{ background: l.statut === "approved" ? "#E6F1FB" : "#FAEEDA", borderRadius: 6, padding: "5px 10px", marginBottom: 4, fontSize: 12, color: "#333" }}>
                        {l.type} — {new Date(l.date_debut).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" })} → {new Date(l.date_fin).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" })} ({parseFloat(l.jours)}j)
                        <span style={{ marginLeft: 8, fontSize: 10, color: l.statut === "approved" ? "#3B6D11" : "#854F0B" }}>
                          {l.statut === "approved" ? "✅" : "⏳"}
                        </span>
                      </div>
                    ))}
                  </div>
                ))
              }
            </div>
          );
        })}
      </div>

      {/* 3 tableaux empilés — desktop */}
      <div className="planning-table-view">
        {members.length === 0
          ? <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: 12, padding: 32, fontSize: 13, color: "#aaa", textAlign: "center" }}>Aucun membre trouvé.</div>
          : months.map(m => <React.Fragment key={m.label}>{renderMonthTable(m)}</React.Fragment>)
        }
      </div>

      {/* Tooltip */}
      {tooltip && (
        <div style={{
          position: "fixed", top: tooltip.y + 12, left: tooltip.x + 8,
          background: "rgba(30,30,40,0.92)", color: "#fff",
          padding: "6px 10px", borderRadius: 6, fontSize: 11, pointerEvents: "none",
          zIndex: 1000, maxWidth: 260, lineHeight: 1.4, boxShadow: "0 2px 8px rgba(0,0,0,0.2)"
        }}>
          {tooltip.text}
        </div>
      )}
    </div>
  );
}

export default Planning;
